import { render, staticRenderFns } from "./ItemAttachmentsPopup.vue?vue&type=template&id=71a1d606&scoped=true"
import script from "./ItemAttachmentsPopup.vue?vue&type=script&lang=js"
export * from "./ItemAttachmentsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a1d606",
  null
  
)

export default component.exports